import { supabase } from './supabase';

const ROTEIROS_BUCKET = 'roteiros';

export async function carregarDadosPortal(token) {
  const { data, error } = await supabase.rpc('portal_get_dados', { p_token: token });
  if (error) throw new Error(error.message);
  if (data?.erro) throw new Error(data.erro);
  return data;
}

export async function subirRoteiro(projetoId, conteudoId, file) {
  const path = `${projetoId}/${conteudoId}.docx`;
  const { error } = await supabase.storage.from(ROTEIROS_BUCKET).upload(path, file, {
    upsert: true,
    contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  });
  if (error) throw new Error(error.message);
  return path;
}

export async function subirRoteiroLote(projetoId, loteId, file) {
  const path = `${projetoId}/lote-${loteId}.docx`;
  const { error } = await supabase.storage.from(ROTEIROS_BUCKET).upload(path, file, {
    upsert: true,
    contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  });
  if (error) throw new Error(error.message);
  return path;
}

export async function removerRoteiro(path) {
  const { error } = await supabase.storage.from(ROTEIROS_BUCKET).remove([path]);
  if (error) throw new Error(error.message);
}

export async function urlAssinadaRoteiro(path, expiraEmSegundos = 3600) {
  const { data, error } = await supabase.storage.from(ROTEIROS_BUCKET).createSignedUrl(path, expiraEmSegundos);
  if (error) throw new Error(error.message);
  return data.signedUrl;
}

export async function gerarNovoTokenPortal(projetoId) {
  const novoToken = crypto.randomUUID();
  const { data, error } = await supabase.from('projetos').update({ portal_token: novoToken }).eq('id', projetoId).select('portal_token').single();
  if (error) throw new Error(error.message);
  return data.portal_token;
}

export function linkPortal(token) {
  return `${window.location.origin}/portal/${token}`;
}

export async function carregarRelatorioPortal(token, inicio, fim) {
  const { data, error } = await supabase.rpc('portal_get_relatorio', { p_token: token, p_inicio: inicio, p_fim: fim });
  if (error) throw new Error(error.message);
  if (data?.erro) throw new Error(data.erro);
  return data;
}

export async function marcarEventoRoteiro(token, conteudoId, etapa, marcar, detalhe) {
  const { data, error } = await supabase.rpc('portal_marcar_evento_roteiro', { p_token: token, p_conteudo_id: conteudoId, p_etapa: etapa, p_marcar: marcar, p_detalhe: detalhe || null });
  if (error) throw new Error(error.message);
  if (data?.erro) throw new Error(data.erro);
  return data;
}

export async function escolherConteudo(token, conteudoId, escolher) {
  const { data, error } = await supabase.rpc('portal_escolher_conteudo', { p_token: token, p_conteudo_id: conteudoId, p_escolher: escolher });
  if (error) throw new Error(error.message);
  if (data?.erro) throw new Error(data.erro);
  return data;
}

export async function trocarVideoTiktok(token, atualId, novoId) {
  const { data, error } = await supabase.rpc('portal_trocar_video_tiktok', { p_token: token, p_atual_id: atualId, p_novo_id: novoId });
  if (error) throw new Error(error.message);
  if (data?.erro) throw new Error(data.erro);
  return data;
}

export async function salvarPersonaPortal(token, respostas, observacoes) {
  const { data, error } = await supabase.rpc('portal_salvar_persona', { p_token: token, p_respostas: respostas, p_observacoes: observacoes || null });
  if (error) throw new Error(error.message);
  if (data?.erro) throw new Error(data.erro);
  return data;
}
